import React from 'react';
import { Chip } from '@mui/material';
import { deriveStatus, STATUS_META } from '../../lib/billStatus';

// 계산서 행에서 status 를 파생해 뱃지로 표시
const StatusBadge = ({ bill, status }) => {
  const s = status || deriveStatus(bill);
  const meta = STATUS_META[s] || { label: s, color: 'default' };
  return <Chip size="small" color={meta.color} label={meta.label} variant="outlined" />;
};

export default StatusBadge;
